import { Helmet } from "react-helmet-async";
import { productImg1 } from "src/assets/images/images";
import useScrollOnMount from "src/hooks/App/useScrollOnMount";
import CategoriesSection from "./catogries-section/CategoriesSection";
import FeaturedSection from "./featuredsection/FeaturedSection";
import FeaturedSectionFeatures from "./featuredsection/FeaturedSectionFeatures";
import s from "./Home.module.scss";
import MainSlider from "./introduction/MainSlider/MainSlider";
import SectionsMenu from "./introduction/sectionmenu/SectionsMenu";
import OurProductsSection from "./ourproductsection/OurProductsSection";
import ProductPoster from "./productposter/ProductPoster";
import ThisMonthSection from "./thisMonthsection/ThisMonthSection";
import TodaySection from "./todaysection/TodaySection";

const Home = () => {
  useScrollOnMount(0);

  return (
    <>
      <Helmet>
        <title>Shoploom</title>
        <meta
          name="description"
          content="Your ultimate destination for effortless online shopping. Discover curated collections, easily add items to your cart and wishlist,and enjoy detailed product descriptions with captivating previews. Experience convenience like never before with our intuitive interface. Shop smarter with us today."
        />
        <link ref="preload" as="image" type="image/webp" href={productImg1} />
      </Helmet>

      <main className={s.home}>
        <div className={s.container}>
          <div className={s.introductionContainer}>
            <SectionsMenu />

            <div className={s.line} />

            <MainSlider />
          </div>

          <TodaySection />
          <CategoriesSection />
          <ThisMonthSection />
          <ProductPoster />
          <OurProductsSection />
          <FeaturedSection />
          <FeaturedSectionFeatures />
        </div>
      </main>
    </>
  );
};

export default Home;
